import { Expose } from 'class-transformer';

import { SnModel } from '@lib/common/models';

export class SnCameraUrls extends SnModel {
  @Expose()
  public id: string;

  @Expose()
  public name: string;

  @Expose()
  public discoveryUrls: string;

  @Expose()
  public liveUrls: string;

  @Expose()
  public liveVideoUrls: string;

  @Expose()
  public nimbleUrls: string;

  @Expose()
  public playbackUrls: string;

  @Expose()
  public prerecordingUrls: string;

  @Expose()
  public unmanagedUrl: string;

  @Expose()
  public unmanagedUrlSub: string;

  @Expose()
  public record: boolean;

  @Expose()
  public overlayImage: string;

  constructor(data: any = {}) {
    super();

    this.fromJSON(data);
  }
}
